export class ProductionLogRequest {
  lotNumber: string;
  fromDate?: any;
  toDate?: any;
  unitId?: number;
}
